import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import * as MindElixir from 'mind-elixir';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import { DomSanitizer, SafeHtml, SafeValue } from '@angular/platform-browser';
import {
  faAngleLeft,
  faAngleRight,
  faChevronLeft,
  faChevronRight,
  faFileExport,
  faInfoCircle,
  faMinus,
  faPlus,
  faProjectDiagram,
  faStepBackward,
  faStepForward,
  faUser,
  faTable,
  faCircle,
  faSearch,
  faExchangeAlt,
  faArrowAltCircleRight
} from '@fortawesome/free-solid-svg-icons';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import { MainComponent } from '../main/main.component';
import { faConnectdevelop } from '@fortawesome/free-brands-svg-icons';
import { PagerService } from '../shared/services/pager.service';
import { SocketService } from '../shared/services/socket.service';
import { Subscription } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { ReloadToolService } from '../shared/services/reload-tool.service';
declare var $: any;
@Component({
  selector: 'app-mind-elixir-mindmapping',
  templateUrl: './mind-elixir-mindmapping.component.html',
  styleUrls: ['./mind-elixir-mindmapping.component.scss'],
  encapsulation: ViewEncapsulation.None // Disable encapsulation
})
export class MindElixirMindmappingComponent implements OnInit {
  mind: any; // or specify the type based on your needs
  clickEventsubscriptionSocket: Subscription;
  clickEventsubscription: Subscription;
  modelData: any;
  personaMap: any;
  interactionMap: any;
  listOfEUTs: any;
  scopeMapper: any;
  selectedEUT: any;
  persona: any;
  EUTtypes = ["TF", "UR", "BF"];
  nodeData: any;
  childrenArray: any;
  modules: any;
  listOfAttributes: any;
  listOfEnv: any;
  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private socketService: SocketService,
    private Config: Config,
    private reloadToolService: ReloadToolService,
    private appService: AppService,
    public mainComponent: MainComponent,
    private pagerService: PagerService,
    private sanitizer: DomSanitizer,
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });
    this.clickEventsubscription = this._sharedService
      .getClickEvent()
      .subscribe((eut) => {
        // this.activate(eut);
      })
  }
  mindMapData: any
  ngOnInit(): void {
    console.log("Mind-elixir");
    this.modelData = this._sharedService.loadedProjectData.model;
    this.personaMap = this.modelData.personaMap;
    this.persona = this.modelData.persona;
    this.modules = this.modelData.modules;
    this.listOfAttributes = this.modelData.listOfAttributes;
    this.listOfEnv = this.modelData.listOfEnv;
    this.interactionMap = this.modelData.interactionMap;
    this.listOfEUTs = this.modelData.listOfEUTs;
    this.scopeMapper = this.modelData.scopeMapper;
    var mindMapList = ["Personas", "Modules", "Environments", "Attributes", "Levels"];
    // console.log("this.modelData", this.modelData);
    this.childrenArray = [];
    for (var i = 0; i < mindMapList.length; i++) {
      if (mindMapList[i] == "Modules") {
        let modulesObject: any = {
          "topic": mindMapList[i],
          "id": this.uuidv4(),
          // tags: ['Tag'],
          // "icons": ['😀'],
        };
        let modulesSubchild: any = []
        for (var j = 0; j < this.modules.length; j++) {
          let module: any = {};
          module['topic'] = this.modules[j].mName
          module['id'] = this.modules[j].mID

          let entitySubchild: any = []
          for (var l = 0; l < this.listOfEUTs.length; l++) {
            if (this.modules[j].mID == this.listOfEUTs[l].mID) {
              let entity: any = {};
              entity['topic'] = '(' + this.listOfEUTs[l].eType + ') ' + this.listOfEUTs[l].eName
              entity['id'] = this.listOfEUTs[l].eID

              entitySubchild.push(entity)
            }
          }
          module['children'] = entitySubchild;
          modulesSubchild.push(module);
        };
        modulesObject['children'] = modulesSubchild;
        this.childrenArray.push(modulesObject);
      }
      if (mindMapList[i] == "Personas") {
        let personaObject: any = {
          "topic": mindMapList[i],
          "id": this.uuidv4(),
          // "icons": ["\f007"],
          // "style": { fontSize: '32', color: '#3298db', background: '#ecf0f1' },
        }
        let personasSubchild: any = [];
        for (let k = 0; k < this.persona.length; k++) {
          let persona: any = {};
          persona['topic'] = this.persona[k].pName
          persona['id'] = this.persona[k].pID

          personasSubchild.push(persona);
        }
        personaObject['children'] = personasSubchild;
        this.childrenArray.push(personaObject);
      }
      if (mindMapList[i] == "Attributes") {
        let attributesObject: any = {
          "topic": mindMapList[i],
          "id": this.uuidv4()
        }
        let attributeSubchild: any = [];
        for (let k = 0; k < this.listOfAttributes.length; k++) {
          if (this.listOfAttributes[k].aDetail != "") {
            let attribute: any = {};
            attribute['topic'] = this.listOfAttributes[k].aType + ' : ' + this.listOfAttributes[k].aDetail
            attribute['id'] = this.uuidv4()
            attributeSubchild.push(attribute);
          }
        }
        attributesObject['children'] = attributeSubchild;
        this.childrenArray.push(attributesObject);
      }
      if (mindMapList[i] == "Environments") {
        let environmentObject: any = {
          "topic": mindMapList[i],
          "id": this.uuidv4()
        }
        let environmentsSubchild: any = [];
        for (let k = 0; k < this.listOfEnv.length; k++) {
          let environment: any = {};
          environment['topic'] = this.listOfEnv[k].envType + ' : ' + this.listOfEnv[k].envValues
          environment['id'] = this.listOfEnv[k].envID

          environmentsSubchild.push(environment);
        }
        environmentObject['children'] = environmentsSubchild;
        this.childrenArray.push(environmentObject);
      }
      if (mindMapList[i] == "Levels") {
        let levelObject: any = {
          "topic": mindMapList[i],
          "id": this.uuidv4()
        }
        this.childrenArray.push(levelObject);
      }
    }
    this.nodeData = {
      "id": this.modelData._id,
      "topic": this.modelData.projectDetails.name,
      "root": true,
      "children": this.childrenArray
    };

    this.mindMapData = {
      "nodeData": {
        "id": "8ae27e0480b98558",
        "topic": "Entity",
        "root": true,
        "children": [
          {
            "topic": "Personas",
            "id": "8ae28030353a5bd1",
            "children": [
              {
                "topic": "Admin",
                "id": "8ae281d371bbd6e8"
              },
              {
                "topic": "Manager",
                "id": "8ae28323068d2ca4"
              }
            ]
          },
          {
            "topic": "EUT 1",
            "id": "8ae285dc1ebc3093"
          }
        ]
      },
      "linkData": {},
      "direction": 0,
      "theme": {
        "name": "Latte",
        "palette": [
          "#dd7878",
          "#ea76cb",
          "#8839ef",
          "#e64553",
          "#209fb5",
          // "#df8e1d",
          // "#40a02b",
          // "#209fb5",
          // "#1e66f5",
          // "#7287fd"
        ],
        "cssVar": {
          "--main-color": "#444446",
          "--main-bgcolor": "#ffffff",
          "--color": "#777777",
          "--bgcolor": "#f6f6f6"
        }
      }
    };
    console.log("nodeData", this.nodeData);
    this.mindMapData['nodeData'] = this.nodeData;

  }
  ngAfterViewInit() {
    const mind = new MindElixir({
      el: '#map',
      direction: MindElixir.SIDE,
      // or set as data that is return from `.getAllData()`
      data: this.mindMapData,
      draggable: false, // default true
      contextMenu: true, // default true
      toolBar: true, // default true
      nodeMenu: true, // default true
      keypress: true, // default true
      scale: 0.4,

      // locale: 'en', // [zh_CN,zh_TW,en,ja,pt,ru] waiting for PRs
      // overflowHidden: true, // default false
      // mainLinkStyle: 2, // [1,2] default 1
      // mainNodeVerticalGap: 15, // default 25
      // mainNodeHorizontalGap: 15, // default 65
      // contextMenuOption: {
      //   focus: true,
      //   link: true,
      //   extend: [
      //     {
      //       name: 'Add persona',
      //       onclick: () => {
      //         alert('extend menu')
      //       },
      //     },
      //     {
      //       name: 'Add entity',
      //     },
      //     {
      //       name: 'Add attributes',
      //     }
      //   ]
      // }
    })
    mind.init(this.mindMapData);
    // mind.refresh(this.mindMapData);
    console.log("root", mind.nodeData.topic);
    mind.bus.addListener('operation', (operation: any) => {
      console.log("Current active node", operation)
      // return {
      //   name: action name,
      //   obj: target object
      // }

      // name: [insertSibling|addChild|removeNode|beginEdit|finishEdit]
      // obj: target

      // name: moveNode
      // obj: {from:target1,to:target2}
    })
    // mind.addListener('selectNode', (node: any) => {
    //   console.log("Current Active node",node);
    // })
    setTimeout(() => {
      // Create a new node
      // const newNode = {
      //   id: 'sdfew234wet23ewd324s',
      //   topic: 'Levels',
      //   direction: 1, // Specify the direction of the node, such as 0 for right, 1 for left, etc.
      // };

      // // Add the new node to the mindmap
      // this.mindMapData.nodeData.children.push(newNode);
      // mind.refresh();
    }, 10000);

    // Call the function to set the scale
    this.setMindmapScale();
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        let r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
  setMindmapScale() {
    const mindmapContainer = $('.map-canvas'); // Replace 'mindmap-container' with the actual selector for your mindmap container element

    // Set the scale using the css() method
    mindmapContainer.css('transform', `scale(${0.4})`);

    // Additional code to customize the mindmap further if needed
  }




}


